var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h5", [_vm._v("Накладная")]),
    _vm._v(" "),
    _vm.trace
      ? _c(
          "table",
          { staticClass: "table table-sm table-striped invoice_trace_table" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.getInvoiceRecords(), function (record, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(index + 1))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.traceActions[record.action] ??
                            `Не определено (${record.action})`
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.printTraceDetail(record)),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.printDate(record.created_at, "DD.MM.YYYY HH:mm")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(_vm.users[record.user_id] || "Автоматически")
                    ),
                  ]),
                ])
              }),
              0
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    true
      ? _c("div", [
          _c("div", { staticClass: "flex justify-content-between" }, [
            _c("h5", [_vm._v("Препараты")]),
            _vm._v(" "),
            _vm.invoiceType === "income"
              ? _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showDiff,
                          expression: "showDiff",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.showDiff)
                          ? _vm._i(_vm.showDiff, null) > -1
                          : _vm.showDiff,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.showDiff,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.showDiff = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.showDiff = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.showDiff = $$c
                            }
                          },
                          _vm.updateRecords,
                        ],
                      },
                    }),
                    _vm._v(" показать изменения после приемки\n        "),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.trace
            ? _c(
                "table",
                {
                  staticClass:
                    "table table-sm table-bordered table-hover drugs_trace_table",
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th"),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          class: {
                            pointer: true,
                            active: _vm.sorting.field === "name",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.updateSorting("name")
                            },
                          },
                        },
                        [
                          _vm._v("Препарат\n          "),
                          _c("i", {
                            staticClass: "icon-fa icon-fa-sort-amount-desc",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          class: {
                            pointer: true,
                            active: _vm.sorting.field === "created_at",
                          },
                          attrs: { width: "170" },
                          on: {
                            click: function ($event) {
                              return _vm.updateSorting("created")
                            },
                          },
                        },
                        [
                          _vm._v("Действие, Дата "),
                          _c("i", {
                            staticClass: "icon-fa icon-fa-sort-amount-desc",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("th", [_vm._v("Количество")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Стоимость")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Пользователь")]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.records, function (record, index) {
                        return [
                          _c("tr", [
                            _c(
                              "td",
                              { attrs: { rowspan: record.trace.length } },
                              [_vm._v(_vm._s(index + 1))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { attrs: { rowspan: record.trace.length } },
                              [
                                _vm._v(
                                  _vm._s(record.drug && record.drug.title) +
                                    "\n            (" +
                                    _vm._s(record.drug && record.drug.id) +
                                    ")\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.traceActions[record.trace[0].action] ||
                                      "Не определено"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.printDate(record.trace[0].created_at)
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(record.trace[0].qty))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  record.trace[0].income_price ??
                                    record.trace[0].price
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.users[record.trace[0].user_id] ||
                                    "Автоматически"
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._l(record.trace, function (trace, index) {
                            return index > 0
                              ? _c("tr", [
                                  _c("td", [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.traceActions[trace.action] ||
                                            "Не определено"
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(_vm.printDate(trace.created_at))
                                      ),
                                    ]),
                                  ]),
                                  _c("td", [_vm._v(_vm._s(trace.qty))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(trace.income_price ?? trace.price)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.users[trace.user_id] ||
                                          "Автоматически"
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e()
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Действие")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("Пользователь")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }